module.exports = __webpack_public_path__ + "img/cover-slot-bg-mobile.686ca3a8.jpg";